"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        display: 'block',
        width: 67,
        height: 'auto',
        stroke: 'currentColor'
    }
};
//# sourceMappingURL=avatar.styles.js.map